module.exports = __webpack_public_path__ + "img/sanjose.9f96b4bc.png";